import { translate } from '@lucidlink/uicore';
import { CACHE_SIZE_RANGES } from '#constants';
const { LOWER, UPPER } = CACHE_SIZE_RANGES;
export const cacheSizeValidationRules = () => [
    {
        errorCodes: ['cacheSize.range'],
        label: translate('Must be between {{LOWER}} and {{UPPER}}', {
            LOWER,
            UPPER,
        }),
    },
];
export const rateLimitValidationRules = () => [
    {
        errorCodes: ['rateLimit.range'],
        label: translate('Acceptable values: digits only'),
    },
];
export const teamCacheValidationRules = () => [
    {
        errorCodes: ['teamCache.location'],
        label: translate('Must be a valid URL'),
    },
];
